import {AfterViewInit, ChangeDetectorRef, Component, HostListener, NgZone, OnDestroy, OnInit} from "@angular/core";
import {
  GetPagedOrderQuery,
  Merchant,
  OrderControllerService, OrderItem,
  OrderReq, Payment,
  TableMerchant,
  TableMerchantControllerService,
  TaxConfig,
  UserShiftRes
} from "../../@services/gen";
import { ActivatedRoute, Router } from "@angular/router";
import { TdDialogService } from "@covalent/core/dialogs";
import { lcdScreen, printz, secondScreen } from "../../@services/utils";
import { AuthService } from "../../@services/auth.service";
import { UserModel } from "../../@models/user.model";
import { PaymentService } from "../../@services/payment.service";
import { forkJoin, Subject, switchMap, take, takeUntil, tap } from "rxjs";
import { LocalstorageService } from "../../@services/localstorage.service";
import { TaxService } from "../../@services/tax.service";
import { OrderService } from "../../@services/order.service";
import { NotificationService } from "../../@services/notification.service";
import { Order } from "src/app/@services/gen/model/order";
import { KitchenService } from "../../@services/kitchen.service";
import { UserShiftService } from "../../@services/user-shift.service";
import { TableListComponent } from "../table-list/table-list.component";
import {
  ExtendedOrder,
  ExtendedOrderItems,
  PosSplitBillDialogComponent
} from "../pos/pos-split-bill-dialog/pos-split-bill-dialog.component";
import dayjs from "dayjs";
import OrderStatusEnum = Order.OrderStatusEnum;
import KitchenOrderStatusEnum = Order.KitchenOrderStatusEnum;
import { FeatureService } from "../../@services/feature.service";
import {PrinterConfigDialogComponent} from "../user-profile/printer-config-dialog/printer-config-dialog.component";
import {ManagerAuthService} from "../../@services/manager-auth.service";
import OrderTypeEnum = OrderItem.OrderTypeEnum;
import {
  PosCustomerOrderReceiptDialogComponent
} from "../pos/pos-customer-order-receipt-dialog/pos-customer-order-receipt-dialog.component";

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss'],
})
export class CheckoutComponent implements OnInit, AfterViewInit, OnDestroy {
  isMobile: boolean = false;
  isSelectTable: boolean = false;
  tables: TableMerchant[] = [];
  merchant: Merchant = {};
  unpaidOrders: ExtendedOrder[] = [];
  newOrders: ExtendedOrder[] = [];
  subtotal: number = 0;
  tax1Amount: number = 0;
  tax2Amount: number = 0;
  inclusiveTax: number = 0;
  totalAmount: number = 0;
  roundingAmount: number = 0;
  discountItemAmount: number = 0;
  netAmount: number = 0;
  orderQuantity: number = 0;
  toBePaidTotal: number = 0;
  toBePaidQty: number = 0;
  toBePaidTax1: number = 0;
  toBePaidTax2: number = 0;
  selectedTable: TableMerchant;
  user: UserModel;
  taxRates: {tax1Config: TaxConfig; tax2Config: TaxConfig};
  loadUnpaidOrders$: Subject<OrderReq[]> = new Subject<OrderReq[]>();
  selectedTable$: Subject<number> = new Subject<number>();
  loading = {
    unpaidOrder: false,
  };
  userRole;

  private intervalId: number | null = null;
  private userShift: UserShiftRes;
  private unsubscribe$ = new Subject<void>();

  activeTab: OrderTypeEnum = OrderTypeEnum.DineIn; // Default to Dine In

  constructor(
    private tableService: TableMerchantControllerService,
    private orderService: OrderControllerService,
    private customerAuthService: AuthService,
    private customPaymentService: PaymentService,
    private customKitchenService: KitchenService,
    private ds: TdDialogService,
    private router: Router,
    private route: ActivatedRoute,
    private ns: NotificationService,
    private ls: LocalstorageService,
    private customTaxService: TaxService,
    private customOrderService: OrderService,
    private customUserShiftService: UserShiftService,
    private usershiftservice: UserShiftService,
    private fs: FeatureService,
    private zone: NgZone,
    private cdr:ChangeDetectorRef,
    private managerAuthService: ManagerAuthService
  ) {
    this.checkIsMobile();
  }

  ngOnInit(): void {
    this.user = this.customerAuthService.getUser();
    this.userRole = this.user.role;

    this.merchant = this.ls.getMerchant();
    this.userShift = this.customUserShiftService.getUserShift();
    this.taxRates = this.customTaxService.getTaxRates();

    this.resetSecondScreen();
    this.initListener();

    this.route.queryParams.subscribe((qp) => {
      let tableId = qp['tableId'];
      if (tableId) {
        this.selectTable(+tableId);
      }
    });

    this.load();

    if (this.fs.isFeatureEnabled('requirePrinterId')) {
      this.printerConfig();
    }
    // 10000 milliseconds = 10 seconds
  }

  ngAfterViewInit(): void {
    this.zone.runOutsideAngular(() => {
      this.customKitchenService.startTimerIncomingKitchenOrder();

      this.intervalId = setInterval(() => {
        this.loadTablesWithoutRefresh();
      }, 10000);
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkIsMobile();
  }

  private checkIsMobile() {
    this.isMobile = window.innerWidth < 768; // You can adjust the threshold as needed
  }

  private initListener() {
    this.customPaymentService.paymentComplete$.subscribe((isComplete) => {
      if (isComplete) {
        this.ns.showNotification({message: 'Order has been paid'});
        this.loadTables();
        this.unpaidOrders = [];
        this.calculateOrderTotalAmount();
      }
    });

    this.selectedTable$
      .pipe(
        tap((val) => {
          this.selectedTable = {id: val};
          this.unpaidOrders = [];
          this.newOrders = [];
          this.calculateOrderTotalAmount();
        }),
        switchMap((val) => {
          return this.tableService.getTableMerchantPost({
            id: val,
          });
        })
      )
      .subscribe((table) => {
        this.selectedTable = { ...table };
        let selectedTableIndex = this.tables.findIndex((x) => x.id === table.id);
        if (selectedTableIndex > -1) {
          this.tables[selectedTableIndex] = table;
        }

        if (table.totalOrder > 0) {
          this.loadUnpaidOrders(table);

          if (
            table?.name.toLowerCase().includes('ta') ||
            table?.name.toLowerCase().includes('take away') ||
            table?.name.toLowerCase().includes('bungkus')
          ) {
            this.activeTab = OrderTypeEnum.TakeAway;
          } else {
            this.activeTab = OrderTypeEnum.DineIn;
          }

        } else {
          this.resetSecondScreen();
        }
      });
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private load() {
    this.loadTables();
    // this.usershiftservice.checkShiftValid();
  }

  private loadTables() {
    let dialogRef = this.ns.showNotification({
      message: 'Loading tables...',
      icon: 'fa fa-sync',
      manualClose: true,
    });

    this.tableService
      .getPagedTableMerchantPost({
        merchantId: this.merchant.id,
        search: '',
        pageRequest: {
          page: 0,
          size: 999,
        },
      })
      .subscribe((res) => {
        dialogRef.close();

        this.tables = res.content;
      });
  }

  private loadTablesWithoutRefresh() {
    this.tableService
      .getPagedTableMerchantPost({
        merchantId: this.merchant.id,
        search: '',
        pageRequest: {
          page: 0,
          size: 999,
        },
      })
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        // test dulu check every 10secs baru dia trigger change detection
/*
        this.tables = [...res.content.map((table) => {
          return {
            ...table,
            name: "TableX " + table.name
          }
        })];
*/
        this.tables = [...res.content];

        this.zone.run(args => this.cdr.detectChanges())
      });
  }

  selectTable(tableId: number) {
    this.selectedTable$.next(tableId);
    this.isSelectTable = true;
  }

  private loadUnpaidOrders(table: TableMerchant) {
    let shiftStartDate = this.customUserShiftService.getUserShift().start;
    this.loading.unpaidOrder = true;
    this.orderService
      .getPagedOrderPost({
        merchantId: this.merchant.id,
        tableId: table.id,
        orderStatusEnum: [
          GetPagedOrderQuery.OrderStatusEnumEnum.New,
          GetPagedOrderQuery.OrderStatusEnumEnum.Unpaid,
          GetPagedOrderQuery.OrderStatusEnumEnum.PartiallyPaid,
        ],
        orderItemStatusEnum: [
          GetPagedOrderQuery.OrderStatusEnumEnum.New,
          GetPagedOrderQuery.OrderStatusEnumEnum.Unpaid,
          GetPagedOrderQuery.OrderStatusEnumEnum.PartiallyPaid,
        ],
        startDate: shiftStartDate,
        endDate: dayjs(new Date()).endOf('day').toString(),
        pageRequest: {
          page: 0,
          size: 9999,
          orders: [{direction: 'DESC', property: 'creationTime'}],
        },
      })
      .subscribe((res) => {
        this.loading.unpaidOrder = false;
        this.unpaidOrders = (res.content as OrderReq[]).map((order) => ({
          ...order,
          discountAmount: 0,
          toBePaidTotal: 0, // Initialize to satisfy ExtendedOrder and enable split bill detection
          orderItems: order.orderItems.map((item) => ({
            ...item,
            tempQty: item.quantity - item.paidQuantity,
            paidQuantity: item.paidQuantity,
            toBePaidQuantity: item.quantity - item.paidQuantity,
          })),
        })) as ExtendedOrder[];

        this.newOrders = this.unpaidOrders.filter((x) => x.orderStatus === OrderStatusEnum.New);
        this.calculateOrderTotalAmount();

        this.loadUnpaidOrders$.next(this.unpaidOrders);
        console.log(this.merchant.secondScreenBanner);



        if (!this.isMobile) {
          secondScreen({
            backgroundUrl: this.merchant.secondScreenBanner,
            merchantName: this.merchant.storeName || this.merchant.companyName,
            merchantLogoUrl: this.merchant['merchantLogoSmall'],
            orderItems: this.unpaidOrders.flatMap((o) => o.orderItems),
            payment: undefined,
            discountAmount: 0,
            discountItemAmount: this.discountItemAmount,
            netAmount: this.netAmount,
            quantity: this.orderQuantity,
            roundingAmount: this.roundingAmount,
            subtotal: this.subtotal,
            tax1Amount: this.tax1Amount,
            tax2Amount: this.tax2Amount,
            totalAmount: this.totalAmount,
          });
        }
      });
  }

  calculateOrderTotalAmount() {
    const calculatedValues = this.customOrderService.calculateOrderValues(this.unpaidOrders);
    this.subtotal = calculatedValues.paymentSubtotalOrder;
    this.tax1Amount = calculatedValues.tax1Amount;
    this.tax2Amount = calculatedValues.tax2Amount;
    this.inclusiveTax = calculatedValues.inclusiveTax;
    this.totalAmount = calculatedValues.totalAmount;
    this.roundingAmount = calculatedValues.roundingAmount;
    this.discountItemAmount = calculatedValues.paymentDiscountItemOrder;
    this.netAmount = calculatedValues.netAmount;
    this.orderQuantity = calculatedValues.quantity;
    this.toBePaidTotal = calculatedValues.paymentTotalOrder;
    this.toBePaidQty = calculatedValues.paymentQtyOrder;
    this.toBePaidTax1 = calculatedValues.paymentTotalTax1;
    this.toBePaidTax2 = calculatedValues.paymentTotalTax2
  }

  pay() {
    this.selectTable(this.selectedTable.id);

    this.loadUnpaidOrders$
      .pipe(
        take(1),
        tap((vals) => {})
      )
      .subscribe((newOrders) => {
        if (this.newOrders.length > 0) {
          this.ds.openAlert({
            title: 'Warning',
            message: `You have ${this.newOrders.length} unconfirmed orders. Please confirm or cancel the order before proceed to payment`,
          });
          return;
        }

        this.customPaymentService.unpaidOrdersSub$.next(this.unpaidOrders);
        this.router.navigate(['/payment']);
      });
  }

  printBill() {
    let posId = this.ls.getPosId();
    for (let mvp of this.merchant.merchantVsPrinters.filter(x => x.posId === posId || !x.posId)) {
      if (mvp.printReceipt) {
        this.customPaymentService.getPaymentBill(
          this.selectedTable.id,
          mvp.printer.paperSizeType == 'BIG' ? 45 : 32,
          (res) => {
            printz(
              {
                printerName: mvp.printer.printerName,
                printerType: mvp.printer.printerType,
                vendorId: mvp.printer.printerVendorId,
                ipAddress: mvp.ipAddress,
                macAddress: mvp.macAddress,
              },
              [res]
            );
          }
        );
      }
    }
  }

  printCustomerOrderReceipt(){
    let minHeight = '600px';
    let minWidth = null;

    if (this.isMobile) {
      minHeight = '100vh';
      minWidth = '100vw';
    }

    this.ds
      .open(PosCustomerOrderReceiptDialogComponent, {
        minHeight: minHeight,
        minWidth: minWidth,
        data: {
          tableMerchant: this.selectedTable,
          merchantId: this.merchant.id,
        },
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((res: any) => {
        if (res && res.selectedPaidOrder) {
          // this.unpaidOrders = res.selectedPaidOrder as ExtendedOrder[];
          // this.customPaymentService.unpaidOrdersSub$.next(this.unpaidOrders);
          // this.router.navigate(['/payment']);
        }
      });
  }


  addOrder(table: TableMerchant) {
    this.router.navigate(['/pos'], {
      queryParams: {
        tableId: table.id,
      },
    });
  }

  reprintOrder(order: Order) {
    this.ds
      .openConfirm({
        title: 'Reprint Order',
        message: 'Are you sure to reprint this order? This action cannot be undone',
        acceptButton: 'Yes',
        cancelButton: 'No',
      })
      .afterClosed()
      .subscribe((confirmed) => {
        if (confirmed) {
          let notiRef = this.ns.showNotification({message: 'Reprint order...'});

          this.orderService.reprintOrderItemPost({id: order.id}).subscribe(x => {
            notiRef.close();
          })
        }
      });
  }

  editOrder(order: Order) {
    if (this.fs.isFeatureEnabled('editTransactionPermission')) {
      this.checkEditPermission(order);
    } else {
      this.editOrderProcess(order);
    }
  }

  private editOrderProcess(order: Order) {
    this.router.navigate(['/pos'], {
      queryParams: {
        tableId: this.selectedTable.id,
        orderId: order.id,
      },
    });
  }

  private checkEditPermission(order: Order) {
    this.managerAuthService.requireManagerAuth().subscribe(result => {
      if (result && result.success) {
        this.editOrderProcess(order);
      }
    });
  }

  confirmOrder() {
    let obs = this.newOrders.map((order) => {
      let updatedOrderItems = order.orderItems.map((item) => ({
        ...item,
        status: OrderStatusEnum.Unpaid,
        paidAmount: 0,
        paidQuantity: 0,
      }));

      let copyOrder = {
        ...order,
        orderItems: updatedOrderItems,
        orderStatus: OrderStatusEnum.Unpaid,
        kitchenOrderStatus: KitchenOrderStatusEnum.Confirmed,
      };

      return this.orderService.upsertOrderPost({order: copyOrder});
    });
    forkJoin(obs).subscribe((value) => {
      this.ns.showNotification({message: 'Order has been sent to the kitchen!'});
      this.selectTable(this.selectedTable.id);
    });
  }

  cancelOrder(order: Order) {
    if(this.fs.isFeatureEnabled('cancelPermission')){
      this.checkCancelPermission(order);
    } else {
      this.ds
        .openConfirm({
          title: 'Cancel Order',
          message: 'Are you sure to cancel this order? This action cannot be undone',
          acceptButton: 'Yes',
          cancelButton: 'No',
        })
        .afterClosed()
        .subscribe((confirmed) => {
          if (confirmed) {
            this.cancelProcess(order, null ,this.user.username)
          }
        });
    }
  }

  cancelProcess(order: OrderReq, remark?, cancelBy?){
    let notiRef = this.ns.showNotification({message: 'Cancelling order...'});
    this.orderService
      .getOrderPost({
        id: order.id,
      })
      .subscribe((refreshedOrder) => {
        let payload = {...refreshedOrder, orderStatus: 'CANCELLED'} as OrderReq;

        payload.cancelRemarks = remark;
        payload.cancelBy = cancelBy;
        payload.kitchenOrderStatus = KitchenOrderStatusEnum.Cancelled;

        this.orderService
          .upsertOrderPost({
            order: payload,
          })
          .subscribe(
            (x) => {
              notiRef.close();
              this.ns.showNotification({message: 'Order has been cancelled'});
              this.selectTable(this.selectedTable.id);
            },
            (error) => {
              notiRef.close();
              this.ns.showNotification({message: 'Error while cancelling order.'});
            }
          );
      });
  }

  private resetSecondScreen() {
    if (this.fs.isFeatureEnabled('lcdScreen') && !this.isMobile) {
      lcdScreen([
        'Welcome',
        this.merchant.storeName || this.merchant.companyName
      ]);
    }

    if (!this.isMobile) {
      secondScreen({
        backgroundUrl: this.merchant.secondScreenBanner,
        merchantName: this.merchant.storeName || this.merchant.companyName,
        merchantLogoUrl: this.merchant['merchantLogoSmall'],
        orderItems: [],
        payment: undefined,
        discountAmount: 0,
        discountItemAmount: 0,
        netAmount: 0,
        quantity: 0,
        roundingAmount: 0,
        subtotal: 0,
        tax1Amount: 0,
        tax2Amount: 0,
        totalAmount: 0,
      });
    }
  }

  transferTable(pastOrder: OrderReq) {
    let minHeight = '600px';
    let minWidth = null;

    if (this.isMobile) {
      minHeight = '100vh';
      minWidth = '100vw';
    }

    this.ds
      .open(TableListComponent, {
        minWidth: minWidth,
        minHeight: minHeight,
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((res: TableMerchant) => {
        if (res) {
          this.orderService
            .transferTablePost({
              tableId: res.id,
              orderIds: [pastOrder.id],
            })
            .pipe(take(1))
            .subscribe((value) => {
              this.ns.showNotification({message: 'Order has been successfully transferred'});
              this.loadTablesWithoutRefresh();
            });
        }
      });
  }

  splitBill(table: TableMerchant) {
    this.selectTable(this.selectedTable.id);

    let minHeight = '600px';
    let minWidth = null;

    if (this.isMobile) {
      minHeight = '100vh';
      minWidth = '100vw';
    }

    this.ds
      .open(PosSplitBillDialogComponent, {
        minHeight: minHeight,
        minWidth: minWidth,
        data: {
          tableMerchant: table,
          merchantId: this.merchant.id,
        },
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((res: any) => {
        if (res && res.selectedPaidOrder) {
          this.unpaidOrders = res.selectedPaidOrder as ExtendedOrder[];
          this.customPaymentService.unpaidOrdersSub$.next(this.unpaidOrders);
          this.router.navigate(['/payment']);
        }
      });
  }

  getItemSubTotal(item: ExtendedOrderItems) {
    let totalPerItem = item.subtotal / item?.quantity;
    let subTotal = totalPerItem * item?.toBePaidQuantity;
    return subTotal;
  }

  getItemSubTotalWithDiscount(item: ExtendedOrderItems) {
    let totalPerItem = item.subtotal / item?.quantity;
    let subTotal = totalPerItem * item?.toBePaidQuantity;
    let subTotalAfterDiscount = subTotal - subTotal * (item.discountPercentage / 100);
    return subTotalAfterDiscount;
  }

  //Mobile View

  returnCheckoutPage(){
    this.isSelectTable = false;
  }

  printerConfig() {
    let minHeight = null;
    let minWidth = '50%';

    if(this.userRole == 'cashier' && this.merchant.printingHost){
      if(!this.ls.getPosId()){
        this.ds.open(PrinterConfigDialogComponent, {
          minWidth: minWidth,
        })
          .afterClosed()
          .pipe(take(1))
          .subscribe((data) => {
          });
      }
    }
  }

  private checkCancelPermission(order: OrderReq) {
    this.managerAuthService.requireManagerAuth({ requireRemark: true }).subscribe(result => {
      if (result && result.success) {
        this.cancelProcess(order, result.remark, result.username);
      }
    });
  }

  // Function to filter items based on the active tab (orderType)
  getFilteredItems(orderId): any[] {
    // Flatten all orderItems from all unpaidOrder elements and filter by activeTab

    let order = this.unpaidOrders.filter(order => order.id === orderId);

    return order
      ?.flatMap(order => order.orderItems)
      .filter(item => item.prepareType === this.activeTab) || [];
  }

  // Function to switch the tab
  setActiveTab(tab: OrderTypeEnum): void {
    this.activeTab = tab;
  }

  getItemCount(orderType: OrderTypeEnum): number {
    // Flatten all orderItems from all unpaidOrder elements and count the items based on the orderType
    return this.unpaidOrders?.flatMap(order => order.orderItems)
      .filter(item => item.prepareType === orderType).length || 0;
  }

  getRequireBill(){
    if (this.fs.isFeatureEnabled('requirePrintCustomerOrderReceipt')) {
      return false;
    } else {
      return true;
    }
  }

  protected readonly OrderTypeEnum = OrderTypeEnum;
}
